import {
  useFeatureFlags,
  type FeatureFlagDefinitions,
  type FeatureFlagsState,
} from '@trimble/feature-flags';

/* eslint-disable @typescript-eslint/naming-convention -- flag keys are PascalCase, like every app's flag record */
export const MOBILE_MAPPING_FEATURE_FLAG_DEFINITIONS = {
  FeatureExtraction: { config: 'featureExtraction' },
  DeleteWorkspace: { config: 'deleteWorkspace' },
} as const satisfies FeatureFlagDefinitions<string>;
/* eslint-enable @typescript-eslint/naming-convention */

export type MobileMappingFlag =
  keyof typeof MOBILE_MAPPING_FEATURE_FLAG_DEFINITIONS;

export const useMobileMappingFlags = (): FeatureFlagsState<MobileMappingFlag> =>
  useFeatureFlags<MobileMappingFlag>();
